<script>
  import Modal from "../shared/modal.svelte"
  import Basket from "./basket.svelte"
  import {basket,open} from "./basket-store.js"
  import Currency from "./currency.svelte"
  import Dropdown from "../shared/dropdown.svelte"
  export let currency = "GBP"
  basket.load(currency)
  const show = ()=>  $open = true
  const hide = ()=> $open = null

  const changeCurrency = (e)=>{
    currency = e.target.value 
    basket.load(currency)
  }

</script>

<button class="btn btn-default btn-sm" on:click={show}>
    <Currency currency={currency} value={$basket ? $basket.total : 0}></Currency>
  <span class="fa fa-shopping-basket"></span>
</button>
<Modal heading="Basket" open={$open} on:closed={hide} style="width:900px">
  <Basket currency={currency} />
  <div slot="toolbar">
    <div class="pull-left">
      <select class="form-control" on:change={changeCurrency} bind:value={currency}>
        <option value="GBP">£ - GBP</option>
        <option value="USD">$ - USD</option>
        <option value="EUR">€ - EUR</option>
      </select>
    </div>
    <div class="btn-toolbar pull-right">
      <button class="btn btn-default" on:click={hide}>Close</button>
      <a class="btn btn-primary" href="/system/checkout/">Proceed To Checkout</a>
    </div>
  </div>
</Modal>